import lilyPic from "@/public/images/artists/lily.png";
import { Artist } from "@/types/types";

export const lily = {
  id: "186",
  name: "Lily",
  image: lilyPic,
  description: `Lily's voice possesses a bright, crystalline timbre and piercing clarity. Her vocal delivery transitions between ethereal, breathy textures and sharp, staccato precision, striking a balance between delicacy and power.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Flily-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: [
        "Indie",
        "Folk",
        "Unprocessed",
        "Airy",
        "Ethereal",
        "Alternative",
        "Falsetto",
      ],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "Very high",
      },
      specific: {
        low: 55,
        high: 74,
      },
      sweetSpot: 63,
    },
  },
} as const satisfies Artist;
